import { render, staticRenderFns } from "./EncryptionWarningDialog.vue?vue&type=template&id=21c94c20&scoped=true"
import script from "./EncryptionWarningDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EncryptionWarningDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EncryptionWarningDialog.vue?vue&type=style&index=0&id=21c94c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c94c20",
  null
  
)

export default component.exports